import { message, notification } from "antd";
import Api from "network/api";
import { ENTITIES } from "network/models/entities";
import { useMutation, useQuery, useQueryClient } from "react-query";
import QueryUtil from "utils/query.util";

export function useGetUsers() {
  const query = useQuery([ENTITIES.GET_USERS], () => Api.instance.getUsers());
  return QueryUtil.processGetQuery(query as any);
}

export function useLogin() {
  const queryClient = useQueryClient();
  const query = useMutation(Api.instance.login, {
    onSuccess: (response) => {
      // Annuli are included in the well request. Therefore invalidate the well request.
      queryClient.invalidateQueries([ENTITIES.LOG_IN]);
    },
    onError: (error: any) => {
      const messages: any[] = error.response.data.message;

      notification.error({
        message: "فشل تسجيل الدخول",
        description: messages[0],
        duration: 2,
      });
    },
  });
  return query;
}
